function getNiceTicks(scale, num) {
  const ticks = scale.ticks(num);
  const diff = ticks[1] - ticks[0];
  const firstTick = ticks[0];
  const lastTick = ticks[ticks.length - 1];
  return [firstTick - diff, ...ticks, lastTick + diff];
}

export default getNiceTicks;
